<template>
  <div>
    <v-tabs v-bind="$attrs" class="d-flex flex flex-column flex-grow-1" show-arrows :value="value" @change="$emit('change',$event)">
      <slot name="tab"></slot>
    </v-tabs>
    <slot name="items"></slot>
  </div>
</template>

<script>
import {VTabs} from "vuetify/lib/components";

export default {
  name: "XTabs",
  props: ['value'],
  extends: VTabs,

  methods: {

  },

  watch: {

  }
}
</script>

<style scoped>

</style>
